// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\equipment.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\equipment.tsx");
  import.meta.hot.lastModified = "1759744975828.3738";
}
// REMIX HMR END

export const meta = () => {
  return [{
    title: "Equipment | Nomadics"
  }, {
    name: "description",
    content: "Professional equipment for rent"
  }];
};
const HeroSection = () => {
  return <section className="bg-black text-white min-h-screen relative px-8 py-16">
      <div className="max-w-7xl mx-auto h-full min-h-screen flex flex-col justify-center relative">
        {/* Main Title - Positioned on the left, moved upward */}
        <div className="absolute top-1/4 left-8 transform -translate-y-1/2">
          <h1 className="text-4xl md:text-6xl lg:text-7xl xl:text-8xl font-black leading-[0.8] tracking-tight text-left">
            THE TOOLS YOU
            <br />
            NEED TO CREATE
          </h1>
        </div>

        {/* Description text - Positioned in bottom right, smaller */}
        <div className="absolute bottom-40 right-8 max-w-xs md:max-w-sm lg:max-w-md">
          <p className="text-lg md:text-sm lg:text-base leading-relaxed text-gray-300 text-left">
            At Nomadic Studios, we know the right tools can make all the
            difference. That's why we provide state-of-the-art, standardized
            equipment across all our locations, ensuring you're familiar with
            the gear no matter where your creativity takes you. From video
            production to music recording, fashion design to prototyping, our
            tools are designed to support creators at every level.
          </p>
        </div>
      </div>
    </section>;
};
_c = HeroSection;
const ConsistentGearSection = () => {
  return <section className="bg-white py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              CONSISTENT GEAR, WHEREVER YOU ARE
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Familiarity breeds creativity. Our studios feature standardized
              equipment, so you'll know exactly how to use the tools you need,
              no matter which location you visit. Focus on your craft—not on
              learning new setups.
            </p>
            <button className="inline-flex items-center px-8 py-3 bg-white border-2 border-black text-black font-semibold hover:bg-black hover:text-white transition-colors duration-300">
              BOOK A STUDIO
              <span className="ml-2">→</span>
            </button>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="bg-gray-900 rounded-lg overflow-hidden shadow-2xl">
                <img src="/eqi-1.png" alt="Professional Studio Setup" className="w-full h-full object-cover aspect-video" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
_c2 = ConsistentGearSection;
const InterconnectedSection = () => {
  return <section className="bg-gray-50 py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-1">
            <div className="relative">
              <div className="bg-black rounded-lg overflow-hidden shadow-2xl">
                <img src="/equ-2.png" alt="High-Speed Network" className="w-full h-full object-cover aspect-video" />
              </div>
            </div>
          </div>

          <div className="order-2">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              INTERCONNECTED FOR SEAMLESS COLLABORATION
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our private, high-speed network connects all Nomadic Studios
              locations, allowing you to securely transfer your digital work
              between studios or collaborate with team members in other cities.
              Your creativity doesn't stop at city limits, and neither do we.
            </p>
            <button className="inline-flex items-center px-8 py-3 bg-white border-2 border-black text-black font-semibold hover:bg-black hover:text-white transition-colors duration-300">
              BOOK A STUDIO
              <span className="ml-2">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>;
};
_c3 = InterconnectedSection;
const StockedEssentialsSection = () => {
  return <section className="bg-white py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              STOCKED WITH ESSENTIALS
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Get started quickly with our in-studio stock of samples,
              materials, and consumables. Whether you need fabric for fashion,
              paints for art, or cables for music production, we've got you
              covered with the essentials.
            </p>
            <button className="inline-flex items-center px-8 py-3 bg-white border-2 border-black text-black font-semibold hover:bg-black hover:text-white transition-colors duration-300">
              BOOK A STUDIO
              <span className="ml-2">→</span>
            </button>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="bg-gray-900 rounded-lg overflow-hidden shadow-2xl">
                <img src="/eqi-3.png" alt="Stocked Essentials" className="w-full h-full object-cover aspect-video" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
_c4 = StockedEssentialsSection;
const ExpertGuidanceSection = () => {
  return <section className="bg-gray-50 py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-1">
            <div className="relative">
              <div className="bg-black rounded-lg overflow-hidden shadow-2xl">
                <img src="/equ-4.png" alt="Expert Guidance Dashboard" className="w-full h-full object-cover aspect-video" />
              </div>
            </div>
          </div>

          <div className="order-2">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              EXPERT GUIDANCE ON-SITE
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Every studio is managed by professionals who know the gear inside
              and out. Whether you're learning a new tool or troubleshooting an
              issue, our team is here to ensure your workflow stays smooth and
              productive.
            </p>
            <button className="inline-flex items-center px-8 py-3 bg-white border-2 border-black text-black font-semibold hover:bg-black hover:text-white transition-colors duration-300">
              BOOK A STUDIO
              <span className="ml-2">→</span>
            </button>
          </div>
        </div>
      </div>
    </section>;
};
_c5 = ExpertGuidanceSection;
const SpecializedRentalsSection = () => {
  return <section className="bg-white py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              SPECIALIZED RENTALS FOR UNIQUE NEEDS
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Need uncommon equipment or planning a project offsite? Take
              advantage of our rental services to access specialized tools,
              event production gear, or anything else you might need to bring
              your vision to life.
            </p>
            <button className="inline-flex items-center px-8 py-3 bg-white border-2 border-black text-black font-semibold hover:bg-black hover:text-white transition-colors duration-300">
              BOOK A STUDIO
              <span className="ml-2">→</span>
            </button>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="bg-gray-900 rounded-lg overflow-hidden shadow-2xl">
                <img src="/eqi-1.png" alt="Specialized Equipment Rentals" className="w-full h-full object-cover aspect-video" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
_c6 = SpecializedRentalsSection;
const ConnectCollaborateSection = () => {
  return <section className="bg-black text-white py-32 px-4">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-16">
          <h2 className="text-3xl md:text-7xl font-black leading-tight mb-8">
            CONNECT, COLLABORATE
            <br />
            AND GROW
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
            Be part of something bigger. Nomadic Studios is more than just a
            place to work - it's a vibrant network of creatives who inspire and
            support each other.
          </p>
        </div>

        <div className="mt-12">
          <button className="inline-flex items-center px-12 py-4 bg-white text-black font-bold text-lg hover:bg-gray-100 transition-colors duration-300">
            APPLY FOR MEMBERSHIP
            <span className="ml-3">→</span>
          </button>
        </div>

        {/* Footer spacing */}
        <div className="mt-24 pt-12 border-t border-gray-800">
          <p className="text-gray-500 text-sm">
            © 2025 Nomadic Studios. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
};
_c7 = ConnectCollaborateSection;
export default function Equipment() {
  return <>
      <HeroSection />
      <ConsistentGearSection />
      <InterconnectedSection />
      <StockedEssentialsSection />
      <ExpertGuidanceSection />
      <SpecializedRentalsSection />
      <ConnectCollaborateSection />
    </>;
}
_c8 = Equipment;
var _c, _c2, _c3, _c4, _c5, _c6, _c7, _c8;
$RefreshReg$(_c, "HeroSection");
$RefreshReg$(_c2, "ConsistentGearSection");
$RefreshReg$(_c3, "InterconnectedSection");
$RefreshReg$(_c4, "StockedEssentialsSection");
$RefreshReg$(_c5, "ExpertGuidanceSection");
$RefreshReg$(_c6, "SpecializedRentalsSection");
$RefreshReg$(_c7, "ConnectCollaborateSection");
$RefreshReg$(_c8, "Equipment");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;